import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { WhiteBoxBlock } from "ui";
import { PlateList } from "components";
import { useStores } from "stores";
import { routes } from "constants/routes";
import { getColumns } from "./getColumns";
import { Flex, Typography } from "antd";
import { ReportOfBidsButton } from "../ContractOperations/ReportOfBids";
import { SendBidButton } from "../ContractOperations/SendBidButton";
import { PlateItem } from "components/PlateList";
import { BidEntityByContract, CONTRACT_STATUS_ENUM } from "interfaces";
import { useEffect } from "react";
import { isStatusIncluded } from "utils";

export const ContractBidsList = observer(({ id }: { id: string }) => {
  const { contractBids, user, contractCard } = useStores();
  const navigate = useNavigate();

  const { isCustomer, isSeniorOperator, isJuniorOperator, isRiskManager } = user.roles;
  const { fiatAmount, paidAmount, status } = contractCard.card;

  const showReportOfBidsButton = isCustomer || isSeniorOperator || isJuniorOperator || isRiskManager;

  const showSendBidButton =
    isCustomer &&
    (fiatAmount !== paidAmount || fiatAmount === 0) &&
    isStatusIncluded(status, [CONTRACT_STATUS_ENUM.DRAFT, CONTRACT_STATUS_ENUM.ACTIVE, CONTRACT_STATUS_ENUM.BLOCKED]);

  useEffect(() => {
    contractBids.fetch();
  }, []);

  return (
    <WhiteBoxBlock>
      <Flex className="margin-bottom-md" justify="space-between" align="center">
        <Flex gap={4} align="center">
          <Typography.Text className="whitebox-title">Заявки на оплату</Typography.Text>
          {contractBids.data.length > 0 && (
            <Typography.Text strong>({contractBids.paginationData.totalElements})</Typography.Text>
          )}
        </Flex>
        <Flex gap="4px">
          {showReportOfBidsButton && <ReportOfBidsButton />}
          {showSendBidButton && <SendBidButton />}
        </Flex>
      </Flex>
      <PlateList<BidEntityByContract, any>
        store={contractBids}
        columns={getColumns()}
        PlateComponent={PlateItem}
        updateWithInterval
        showPagination
        onRow={(record: BidEntityByContract) => ({
          onClick: () => navigate(`/${routes.bids}/${record.id}`),
          className: "cursor-pointer",
        })}
      />
    </WhiteBoxBlock>
  );
});
